// components/ModernizeHR.jsx

const ModernizeHR = ({
  heading = "Ready to Modernise Your HR?",
  description = "Over 10,000 Indian businesses run their entire workforce on Waggex HRMS from payroll to performance, all in one place.",
  buttonText = "Start Free Trial",
  buttonText2 = " Book a Free Demo",
  buttonLink = "https://app.waggex.com/signup",
  buttonLink2 = "/contact-us",
}) => {
  return (
    <section className="w-full bg-[#16385C] px-4 py-10 sm:px-6 md:px-10">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heading */}
        {heading && (
          <h2
            className="
            text-white font-roboto font-bold uppercase
            text-xl sm:text-[28px]
          "
          >
            {heading}
          </h2>
        )}
        {/* Description */}
        {description && (
          <p
            className="
            text-gray-300 mt-4
            text-sm sm:text-base md:text-lg
            max-w-2xl mx-auto
            leading-relaxed
          "
          >
            {description}
          </p>
        )}

        {/* Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row justify-center items-center gap-4">
          <button
            className="
              w-full sm:w-auto
              min-w-55
              px-8 py-3
              rounded-xl
              bg-[#D4DEE9]
              text-[#16385C]
              font-medium
              shadow-md
              transition-all duration-300
              hover:scale-105
            "
            onClick={() => (window.location.href = buttonLink)}
          >
            {buttonText}
          </button>

          <button
            className="
              w-full sm:w-auto
              min-w-55
              px-8 py-3
              rounded-xl
              border border-white/60
              text-white
              font-medium
              transition-all duration-300
              hover:bg-white
              hover:text-[#16385C]
            "
            onClick={() => (window.location.href = buttonLink2)}
          >
            {buttonText2}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ModernizeHR;
